module.exports = __webpack_public_path__ + "img/img-ruleSet-example3.6f168521.png";